// we use custom heading size for hero banner
// eslint-disable-next-line no-restricted-imports
import { Box, Flex, Heading } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import SearchBar from 'ui/snippets/searchBar/SearchBarDesktop';
import SearchBarMobile from 'ui/snippets/searchBar/SearchBarMobile';

export const BACKGROUND_DEFAULT =
  'radial-gradient(103.03% 103.03% at 0% 0%, rgba(183, 148, 244, 0.8) 0%, rgba(0, 163, 196, 0.8) 100%), var(--chakra-colors-blue-400)';
const TEXT_COLOR_DEFAULT = 'white';
const BORDER_DEFAULT = 'none';

// New background with waves - solid colors
const BACKGROUND_WITH_WAVES_LIGHT = '#0a0a0a';
const BACKGROUND_WITH_WAVES_DARK = '#0a0a0a';

const HeroBanner = () => {
  const background = {
    _light:
      config.UI.homepage.heroBanner?.background?.[0] ||
      BACKGROUND_WITH_WAVES_LIGHT,
    _dark:
      config.UI.homepage.heroBanner?.background?.[1] ||
      config.UI.homepage.heroBanner?.background?.[0] ||
      BACKGROUND_WITH_WAVES_DARK,
  };

  const textColor = {
    _light:
      // light mode
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
    // dark mode
    _dark:
      config.UI.homepage.heroBanner?.text_color?.[1] ||
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
  };

  const border = {
    _light:
      config.UI.homepage.heroBanner?.border?.[0] || BORDER_DEFAULT,
    _dark:
      config.UI.homepage.heroBanner?.border?.[1] || config.UI.homepage.heroBanner?.border?.[0] || BORDER_DEFAULT,
  };

  return (
    <Box
      w="100vw"
      position="relative"
      left="50%"
      right="50%"
      marginLeft="-50vw"
      marginRight="-50vw"
      maxH="300px"
      background={ background }
      border={ border }
      pt={{ base: 6, lg: 20 }}
      pb={{ base: 10, lg: 44 }}
      px={{ base: 3, lg: 6 }}
      overflow="hidden"
    >
      <Box
        position="absolute"
        bottom={ 0 }
        left={ 0 }
        right={ 0 }
        top={ 0 }
        h={{ base: '300px', lg: '300px' }}
        backgroundImage="url(/static/waves-light.svg)"
        backgroundPosition="center"
        backgroundRepeat="repeat"
      />
      <Flex
        position="relative"
        zIndex={ 1 }
        maxW="1400px"
        mx="auto"
        direction={{ base: 'column', lg: 'row' }}
        gap={{ base: 4, lg: 8 }}
        alignItems={{ base: 'stretch', lg: 'center' }}
      >
        <Box flexGrow={ 1 }>
          <Heading
            as="h1"
            fontSize={{ base: '24px', lg: '22px' }}
            // lineHeight={{ base: '32px', lg: '44px' }}
            fontWeight={ 500 }
            color={ textColor }
            textAlign={{ base: 'center', lg: 'left' }}
            mb={ 2 }
          >
            The WireScan Blockchain Explorer
          </Heading>
          <Box display={{ base: 'flex', lg: 'none' }}>
            <SearchBarMobile isHeroBanner/>
          </Box>
          <Box display={{ base: 'none', lg: 'flex' }} maxWidth={{ base: '100%', lg: '800px' }}>
            <SearchBar isHeroBanner/>
          </Box>
        </Box>
        { /* <Box
          display={{ base: 'none', lg: 'block' }}
          flexShrink={ 0 }
        >
          <AdBanner platform="mobile" w="fit-content" borderRadius="md" overflow="hidden"/>
        </Box> */ }
      </Flex>
    </Box>
  );
};

export default React.memo(HeroBanner);
